import { CardContentLayout } from 'app/components/layouts';
import React from 'react';
import './HideMyEmailPage.less';
import { Trans, useTranslation } from 'react-i18next';

export default function HideMyEmailPage() {
  const { t } = useTranslation();

  return (
    <CardContentLayout
      title={t('faq.hide_my_email.title')}
      className="hide-my-email-page"
    >
      <p>{t('faq.hide_my_email.paragraph_1')}</p>

      <ul>
        <li>
          <Trans i18nKey="faq.hide_my_email.paragraph_2" />
        </li>

        <li>
          <Trans i18nKey="faq.hide_my_email.paragraph_3" />
        </li>
      </ul>

      <p>{t('faq.hide_my_email.paragraph_4')}</p>
    </CardContentLayout>
  );
}
